import { render, staticRenderFns } from "./RegisterCom.vue?vue&type=template&id=0ac1e452&scoped=true"
import script from "./RegisterCom.vue?vue&type=script&lang=js"
export * from "./RegisterCom.vue?vue&type=script&lang=js"
import style0 from "./RegisterCom.vue?vue&type=style&index=0&id=0ac1e452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1e452",
  null
  
)

export default component.exports